import type { IconSvgObject } from './types';

const LessThanIcon: IconSvgObject = [
  ["path", { d: "M17 4L7 12L17 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LessThanIcon;
